import React, { useState } from 'react';
import { useAuthContext } from '../context/AuthContext';
import styles from '../styles/Connexion.module.css';

import Register from './Register';


const LoginForm = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [showRegister, setShowRegister] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useAuthContext();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const { success, error: loginError } = await login(
            credentials.username, 
            credentials.password
        );

        if (!success) {
            setError(loginError || 'Identifiants incorrects');
        }
    };

    if (showRegister) {
        return <Register onRegisterSuccess={() => setShowRegister(false)} />;
    }

    return (
        <div className={styles.connection_container}>
            <div className={styles.container}>
                
                <form onSubmit={handleSubmit}>
                    <div className={styles.login_container}>
                        <div className={`${styles.title}`}>Connexion</div>
                        <div className={`${styles.inputs}`}>
                        {error && <p className={styles.error}>{error}</p>}
                            <div className={styles.item}>
                                <div className={styles.input_container}>
                                    <img src="/assets/icons/user.svg" alt="user" />
                                    <input
                                        type="text"
                                        name="username"
                                        placeholder="Nom d'utilisateur"
                                        value={credentials.username}
                                        onChange={handleChange}

                                        required
                                    />
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.input_container}>
                                    <div className={styles.password_container}>
                                        <img src="/assets/icons/lock.svg" alt="lock" />
                                        <input
                                            type={showPassword ? "text" : "password"} // type de l'input password ou text 
                                            name="password"
                                            placeholder="Mot de passe"
                                            value={credentials.password} // valeur de l'input password
                                            onChange={handleChange} // fonction de changement de la valeur de l'input password
                                            required // obligatoire
                                        />

                                        <button 
                                            type="button"
                                            className={styles.toggle_password} // classe de l'image
                                            onClick={() => setShowPassword(!showPassword)} // fonction de changement du type de l'input password
                                        >
                                            <img 
                                                src={`/assets/icons/${showPassword ? 'eye' : 'eye-off'}.svg`} // image de l'input password

                                                alt={showPassword ? "Masquer" : "Afficher"}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div  className={`${styles.input_container}`} style={{border: 'none'}}>
                                    <button className={styles.buttonContainer}  type="submit">
                                        <div className={`${styles.connect_button}`}>Se connecter</div>
                                    </button>
                                </div>
                            </div>
                            <div className={styles.separatorGroup}>
                                <div className={styles.separator}></div>
                                <p>ou</p>
                                <div className={styles.separator}></div>
                            </div>
                            <div className={styles.item}> 
                                <div  className={`${styles.input_container}`} style={{border: 'none', backgroundColor: 'transparent', height: '1px'}}>
                                    <button className={styles.buttonContainer} onClick={() => setShowRegister(true)}>
                                        <div className={`${styles.register_button}`}>Créer un compte</div>
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginForm;